import { TWithDataComponent } from "@/ui/lib";
import type { ComponentPropsWithoutRef, PropsWithChildren } from "react";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const BROWSER_NO_VALIDATION_MAP = {
  custom: true,
  browser: false,
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TValidation = keyof typeof BROWSER_NO_VALIDATION_MAP;

export type TFormProps = Omit<
  ComponentPropsWithoutRef<"form">,
  "noValidate"
> &
  PropsWithChildren &
  TWithDataComponent & {
    validation?: TValidation;
  };

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const FORM_DEFAULTS = {
  validation: "custom",
} as const satisfies Required<Pick<TFormProps, "validation">>;
